export default __webpack_public_path__ + "8a7af48ab7f7c4ca1bd58f1233338518.png";